import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../tabs-primitive/tab-panel-primitive.js';
import { TabPrimitive } from '../tabs-primitive/tab-primitive.js';
import '../tabs-primitive/tab-strip-primitive.js';
import 'tabbable';
import '../utils/interaction.js';
import { tabButton, tabButtonStrong } from './tabs.css.js';

function TabInner({ children, ...props }, ref) {
    return (jsxs(TabPrimitive, { "data-fpl-component": "", ...props, ref: ref, className: tabButton, children: [jsx("span", { "aria-hidden": true, className: tabButtonStrong, children: children }), jsx("span", { children: children })] }));
}
TabInner.displayName = 'Tabs.Tab';
/**
 * Tab strips allow users to navigate between two or more related views.
 * Tabs are individual navigation options within a `TabStrip`.
 *
 * @compose { "ancestor": ["Tabs.TabStrip"], "multi": true }
 * @see https://fpl.figma.design/components/tabs/
 */
const Tab = forwardRef(TabInner);

export { Tab };
//# sourceMappingURL=tab.js.map
